import { useContext } from "react";
import { googleMapsAPIContext } from "../contexts";

export const useGoogleMapsApi = () => useContext(googleMapsAPIContext);
